import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { DispatchEventClient, DispatchEventReport, DispatchEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useUpdateDispatchEvent() {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<DispatchEventReportDTO, ProblemDetails, DispatchEventReport>({
    mutationKey: [queryKeys.DispatchEvent.Update],
    mutationFn: (report: DispatchEventReport) => dispatchEventClient.update(report),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
  });
}

export default useUpdateDispatchEvent;
